import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["error", "loading", "results"]

  disconnect() {
    this.cancelRequest()
  }

  search(event) {
    event.preventDefault()
    event.stopPropagation()

    const query = new URLSearchParams(new FormData(event.currentTarget))
    const url = new URL(this.data.get("url"), window.location.origin)
    url.search = query.toString()

    this.loadResults(url)
  }

  paginate(event) {
    event.preventDefault()
    this.loadResults(new URL(event.currentTarget.href, window.location.origin))
  }

  async loadResults(url) {
    this.cancelRequest()

    const request = new AbortController()
    this.request = request
    this.resultsTarget.innerHTML = this.loadingTarget.innerHTML

    try {
      const response = await fetch(url.toString(), {signal: request.signal})
      if (!response.ok) throw new Error(`Search failed with status ${response.status}`)

      const results = await response.text()
      if (this.request !== request) return

      this.resultsTarget.innerHTML = results
      window.history.replaceState({}, "", this.browserUrl(url))
    } catch (error) {
      if (error.name === "AbortError" || this.request !== request) return

      this.resultsTarget.innerHTML = this.errorTarget.innerHTML
    } finally {
      if (this.request === request) this.request = null
    }
  }

  cancelRequest() {
    if (this.request) this.request.abort()
    this.request = null
  }

  browserUrl(searchUrl) {
    const url = new URL(window.location.href)
    url.search = searchUrl.search
    return `${url.pathname}${url.search}${url.hash}`
  }
}
